module.exports = __webpack_public_path__ + "static/marvel-three-dashboard@2x-8f0fd15a2f41bceb8ce6bd49e3b96bdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/user-testing/marvel-three-dashboard@2x.jpg
// module id = 2714
// module chunks = 35783957827783